import { BillingDocumentIntegrationStatus } from "constants/billingDocuments";
import { BillingLedgerEntryStatus } from "constants/billingLedgerEntries";

export const billingDocumentAllowsReversal = billingDocument =>
  [
    BillingDocumentIntegrationStatus.AUTHORISED,
    BillingDocumentIntegrationStatus.PAID,
  ].includes(billingDocument.integrationStatus);

export const billingDocumentIntegrationIsActive = billingDocument =>
  [
    BillingDocumentIntegrationStatus.DRAFT,
    BillingDocumentIntegrationStatus.SUBMITTED,
    BillingDocumentIntegrationStatus.PAID,
    BillingDocumentIntegrationStatus.AUTHORISED,
  ].includes(billingDocument.integrationStatus);

export const expectingDeleteOnAcceptChanges = (
  billingDocument,
  ledgerEntriesByDocumentId,
) => {
  if (!billingDocument.hasFinancialChanges) {
    // shortcut as there are no financial changes to accept.
    return false;
  }

  // check if accepting change will delete this document,
  // don't allow if document has an active integration status
  const ledgerEntries = ledgerEntriesByDocumentId[billingDocument.id] || [];
  const temporaryLedgerEntries = ledgerEntries.filter(
    ({ ledgerEntry }) =>
      ledgerEntry.status === BillingLedgerEntryStatus.TEMPORARY,
  );
  const hasTemporaryLedgerEntries = temporaryLedgerEntries.length > 0;
  const hasActiveIntegration =
    billingDocumentIntegrationIsActive(billingDocument);
  return hasActiveIntegration && !hasTemporaryLedgerEntries;
};

export const integratedBillingDocumentDescription = billingDocument =>
  `${billingDocument.type} ${billingDocument.invoiceNumber} (${billingDocument.integrationStatus})`;
